/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Agent invoicing channel such as 'in_house' or 'showami'
 * @export
 * @interface Invoicing
 */
export interface Invoicing {
}

/**
 * Check if a given object implements the Invoicing interface.
 */
export function instanceOfInvoicing(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InvoicingFromJSON(json: any): Invoicing {
    return InvoicingFromJSONTyped(json, false);
}

export function InvoicingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Invoicing {
    return json;
}

export function InvoicingToJSON(value?: Invoicing | null): any {
    return value;
}

